import React, { useCallback, useEffect, useState } from "react";
import PropType from "prop-types";

/**
 * It takes a string and replaces all the newline characters with HTML line breaks.
 * @returns The text with the new line characters replaced with a break tag.
 */
function replaceWithBr(text = "") {
  return text.replace(/\n/g, "<br />");
}


/**
 * It removes all double line breaks at the beginning of a string
 * @returns The string with the first two line breaks removed.
 */
function removeStartingDoubleLineBreaks(str) {
  return str.replace(/^(\r\n|\n|\r){2,}/, "");
}

const AutoTyping = ({
  textRef,
  active,
  writeInterval,
  delayToWrite,
  onComplete,
  ...props
}) => {
  const [autoTyper, setAutoTyper] = useState("");

  const stringWithoutLineBreakAtStart = removeStartingDoubleLineBreaks(textRef);
  const formatedText = replaceWithBr(stringWithoutLineBreakAtStart);

  const letterWriter = useCallback(() => {
    /* Taking the text and slicing it to the length of the autoTyper. */
    const text = formatedText.slice(0, autoTyper.length + 1);

    setAutoTyper(text);
  }, [autoTyper, textRef]);

  const writer = useCallback(() => {
    setTimeout(() => {
      if (autoTyper.length === formatedText.length) {
        onComplete();
        return;
      }

      letterWriter();
    }, writeInterval);
  }, [autoTyper, textRef, writeInterval, letterWriter]);

  useEffect(() => {
    writer();
  }, [writer]);

  return <span {...props} dangerouslySetInnerHTML={{ __html: autoTyper }} />;
};

AutoTyping.propTypes = {
  textRef: PropType.string,
  active: PropType.bool,
  deleteInterval: PropType.number,
  delayToWrite: PropType.number,
};

AutoTyping.defaultProps = {
  textRef: "Input a string",
  active: true,
  writeInterval: 50,
  delayToWrite: 1000,
};

export default AutoTyping;
